import { render, staticRenderFns } from "./BlockType117.vue?vue&type=template&id=39a32a1f&scoped=true"
import script from "./BlockType117.vue?vue&type=script&lang=ts"
export * from "./BlockType117.vue?vue&type=script&lang=ts"
import style0 from "./BlockType117.vue?vue&type=style&index=0&id=39a32a1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a32a1f",
  null
  
)

export default component.exports